import { render } from "./BasicFileInput.vue?vue&type=template&id=5845854d"
import script from "./BasicFileInput.vue?vue&type=script&lang=js"
export * from "./BasicFileInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\casva\\repos\\cg-vue-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__